import React from 'react';
import {
  StyledHeader,
  StyledTd,
} from '../../../Pages/Questionnaire/index.styles';
import { companiesColors } from '../../../Pages/SuperDashboard/data';
import CommentBtn from './commentBtn';
import { useTranslation } from 'react-i18next';
import TableButton from '../../TableButton';
import { EmissionShare } from '../../../../Ghg/Scope3GoodsAndServices/types';

export default function GoodsPreview({
  state,
  id,
  setActive,
  setState,
  emissionShares = [],
}: {
  state: any;
  id: number;
  setActive: Function;
  setState: Function;
  emissionShares?: EmissionShare[];
}) {
  const { t } = useTranslation();
  const handleCopy = () => {
    const tempState = [...state];
    const item = tempState[id];

    tempState.splice(id, 0, item);
    setState(tempState);
    setActive(id);
  };

  const emissionShare = emissionShares?.[id];

  return (
    <StyledHeader>
      <StyledTd width={33} color={companiesColors[id]}>
        <p>{state[id].name || state[id].name_label || ''}</p>
        <CommentBtn state={state} id={id} />
      </StyledTd>
      <StyledTd width={33} color={companiesColors[id]}>
        {t('goods-and-services.organization')}
      </StyledTd>
      <StyledTd width={33} color={companiesColors[id]}>
        {emissionShare && Math.max(0.01, emissionShare.share * 100).toFixed(2)}
      </StyledTd>
      <StyledTd
        width={0}
        color={companiesColors[id]}
        lastCallCustom
        numberOfIcons="two"
      >
        <TableButton hoverText="copy" icon="copy" onClick={handleCopy} />
        <TableButton
          hoverText="edit"
          icon="edit"
          onClick={() => setActive(id)}
        />
      </StyledTd>
    </StyledHeader>
  );
}
